module.exports = __webpack_public_path__ + "facelifting_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_1_after.jpg
// module id = 1049
// module chunks = 0